/* unplugin-vue-components disabled */import { render } from "./SysCogUpload.vue?vue&type=template&id=0082a519&scoped=true"
import script from "./SysCogUpload.vue?vue&type=script&lang=js"
export * from "./SysCogUpload.vue?vue&type=script&lang=js"

import "./SysCogUpload.vue?vue&type=style&index=0&id=0082a519&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0082a519"]])

export default __exports__